<section class="banner">
  <app-nav class="w-100"></app-nav>
  <div class="container-fluid v4-px-5 v4-adjustment">
    <div class="d-flex justify-content-between pt-5">
      <div class="d-flex">
        <img
          class="img-icon"
          src="../../../../../assets/v-4-icone/history.png"
          alt="loading"
        />
        <h2 class="font-600 v4-color-white">
          {{ "Sustainable training" | translator }}
        </h2>
      </div>
    </div>
    <div class="d-flex justify-content-between flex-wrap my-3 mx-3 w-100">
      <div class="d-flex flex-wrap">
        <span class="d-flex align-items-center">
          <span
            (click)="changeRoute('/home')"
            class="custom-bredcrum-btn d-flex align-items-center"
          >
            {{ "Homepage" | translator }}
          </span>
          <span class=""><i class="pi pi-fw pi-angle-left"></i></span>
        </span>
        <span class="d-flex align-items-center">
          <span
            (click)="changeRoute('/training/task-view')"
            class="custom-bredcrum-btn font-600 d-flex align-items-center"
          >
            {{ "Sustainable training" | translator }}
          </span>
        </span>
      </div>
      <div class="d-flex flex-wrap">
        <div class="mx-2 align-items-center flex-wrap d-flex">
          <a
            [routerLink]="'/training/request'"
            *ngIf="hasPermission('CONTINUOUS_TRAINING_REQUEST', 'c')"
            class="create-training-btn m-2 align-items-center d-flex"
            ><i class="pi pi-plus-circle mx-2"></i
            >{{ "Create  a request" | translator }}</a
          >

          <a
            (click)="ShowDashboard = true; showCalender = false"
            *ngIf="
              hasPermission('CONTINUOUS_TRAINING_DASHBOARD', 'a') 
            "
            class="create-training-btn m-2 align-items-center d-flex"
            ><i class="pi pi-chart-bar mx-2"></i
            >{{ "Show Dashboard" | translator }}</a
          >

          <a
            (click)="ShowDashboard = false; showCalender = false"
            *ngIf="
              hasPermission('CONTINUOUS_TRAINING_REQUEST', 'r') ||  hasPermission('CONTINUOUS_TRAINING', 'r')
            "
            class="create-training-btn m-2 align-items-center d-flex"
            ><i class="pi pi-list mx-2"></i>{{ "Show List" | translator }}</a
          >

          <a
            (click)="ShowDashboard = false; showCalender = true"
            *ngIf="
              hasPermission('CONTINUOUS_TRAINING_REQUEST', 'c') ||  hasPermission('CONTINUOUS_TRAINING', 'r')
            "
            class="create-training-btn m-2 align-items-center d-flex"
            ><i class="pi pi-calendar mx-2"></i
            >{{ "Show Calender" | translator }}</a
          >
        </div>
      </div>
    </div>
  </div>
</section>

<div class="container-fluid v4-bg p-0 pt-4">
  <section
    class="container"
    *ngIf="!createCourseModal && !openCourseModal && !addTrainer"
  >
    <div class="d-flex justify-content-center">
      <div class="pt-3 tabs">
        <p-selectButton
        filterButton
          class="v4-active"
          styleClass="d-flex justify-content-center flex-wrap"
          (onChange)="filter()"
          [options]="tabs"
          [(ngModel)]="selected"
          [multiple]="false"
          optionLabel="name"
          optionValue="value"
        ></p-selectButton>
      </div>
    </div>
    <div class="d-flex justify-content-center">
      <div *ngIf="!ShowDashboard && !showCalender" class="v4-select-bg mt-4">
        <div class="pt-3 d-flex justify-content-center">
          <div class="d-flex mx-2">
            <p-selectButton
            filterButton
              class="v4-active"
              styleClass="d-flex justify-content-center flex-wrap"
              (onChange)="getTrainingRequests()"
              [options]="statusOptions"
              [(ngModel)]="status"
              [multiple]="false"
              optionLabel="name"
              optionValue="value"
            ></p-selectButton>
          </div>
        </div>

        <div class="pt-3 d-flex justify-content-center">
         

          <div class="mx-2 d-inline-block">
            <p-calendar
              class="v4-calander"
              *ngIf="selected == 'WEEKLY'"
              [(ngModel)]="selectedDate"
              [dateFormat]="'dd MM yy'"
              (ngModelChange)="getTrainingRequests()"
              [inputStyle]="{ 'text-align': 'right' }"
              [showIcon]="true"
              dir="ltr"
            >
            </p-calendar>

            <p-calendar
              class="v4-calander"
              *ngIf="selected == 'MONTHLY'"
              [(ngModel)]="selectedDate"
              view="year"
              dateFormat="yy"
              (ngModelChange)="getTrainingRequests()"
              [readonlyInput]="true"
              [inputStyle]="{ 'text-align': 'right' }"
              dir="ltr"
              [showIcon]="true"
            ></p-calendar>
          </div>
          <div class="v4-rotate">
            <i
              pTooltip="{{ 'Reset' | translator }}"
              (click)="refreshFilters()"
              tooltipPosition="top"
              class="fa-solid fa-arrows-rotate mx-3"
            ></i>
          </div>
        </div>
      </div>
    </div>
  </section>

  <app-training-dashboard
    *ngIf="ShowDashboard && !showCalender && !addTrainer"
    [tab]="this.selected"
  >
  </app-training-dashboard>

  <app-training-calander
    *ngIf="showCalender && !ShowDashboard && !addTrainer"
    [training_type]="this.selected"
    (showTraining)="openCourse($event, true)"
  ></app-training-calander>

  <section
    class="container max-width-1700px"
    *ngIf="
      !createCourseModal &&
      !openCourseModal &&
      !ShowDashboard &&
      !showCalender &&
      !addTrainer
    "
  >
    <div
      class="d-flex my-3 flex-wrap justify-content-center"
    >
      <div class="d-flex align-items-center m-2">
        <span class="color-sq-box PENDING"></span>
        <span class="color-txt mx-2">{{ "pending" | translator }}</span>
      </div>
      <div class="d-flex align-items-center m-2">
        <span class="color-sq-box APPROVED"></span>
        <span class="color-txt mx-2">{{ "Accepted" | translator }}</span>
      </div>
      <div class="d-flex align-items-center m-2">
        <span class="color-sq-box TRAINING_CREATED"></span>
        <span class="color-txt mx-2">{{ "Draft" | translator }}</span>
      </div>
      <div class="d-flex align-items-center m-2">
        <span class="color-sq-box REJECTED"></span>
        <span class="color-txt mx-2">{{ "Rejected" | translator }}</span>
      </div>
      <div class="d-flex align-items-center m-2">
        <span class="color-sq-box PUBLISHED"></span>
        <span class="color-txt mx-2">{{ "Published" | translator }}</span>
      </div>
      <div class="d-flex align-items-center m-2">
        <span class="color-sq-box COMPLETED"></span>
        <span class="color-txt mx-2">{{ "completed" | translator }}</span>
      </div>
    </div>
    <div
      class="users-data-table d-flex justify-content-center"
      [ngClass]="{ 'my-3': true }"
    >
      <p-progressSpinner
        [hidden]="!spinner"
        styleClass="w-4rem h-4rem pb-4"
        strokeWidth="8"
        fill="var(--surface-ground)"
        animationDuration=".5s"
      ></p-progressSpinner>

      <app-no-data
        [hidden]="spinner || filterRequestData?.length > 0"
      ></app-no-data>
    </div>

    <div [hidden]="spinner || filterRequestData.length <= 0" class="grey-box">
      <table>
        <thead>
          <tr>
            <th scope="col"></th>
            <th scope="col">{{ "the address" | translator }}</th>
            <th scope="col">{{ "Entities" | translator }}</th>
            <th scope="col">{{ "Description" | translator }}</th>
            <th scope="col" *ngIf="status && status !== 'REJECTED'">
              {{ "Course history" | translator }}
            </th>
            <th scope="col" *ngIf="status && selected == 'MONTHLY'">
              {{ "the month" | translator }}
            </th>
            <th scope="col" *ngIf="status && status === 'REJECTED'">
              {{ "the reason of refuse" | translator }}
            </th>
            <th scope="col">{{ "Action" | translator }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let request of filterRequestData; let i = index">
            <td data-label="" style="width: 0px; background-color: transparent">
              <span class="ms-tabel-td-mob-mr tab-card-width-mob">
                <div class="d-flex tab-num-border-white">
                  <div class="tabel-detail-box">
                    <div
                      [ngClass]="getClasses(request.status)"
                      class="ms-tabel-num-box"
                    >
                      {{ i + 1 }}
                    </div>
                  </div>
                </div>
              </span>
            </td>
            <td data-label="Main Criteria">
              <span class="ms-tabel-td-mob-mr tab-card-width-mob">
                <div class="tabel-detail-box">
                  <span class="tab-scroll">{{ request?.topic }}</span>
                </div>
              </span>
            </td>

            <td data-label="Factor">
              <span class="ms-tabel-td-mob-mr tab-card-width-mob">
                <div class="tabel-detail-box">
                  <span class="tab-scroll"
                    >{{ request?.ou?.name }} ({{
                      request?.ou?.location?.name
                    }})</span
                  >
                </div>
              </span>
            </td>

            <td data-label="Factor">
              <span class="ms-tabel-td-mob-mr tab-card-width-mob">
                <div class="tabel-detail-box">
                  <span
                    class="tab-scroll-for-column-ui"
                    [innerHTML]="request?.description | safeHTML"
                    >{{ request?.description }}</span
                  >
                </div>
              </span>
            </td>

            <td *ngIf="status && status !== 'REJECTED'" data-label="Factor">
              <span class="ms-tabel-td-mob-mr tab-card-width-mob">
                <div class="tabel-detail-box">
                  <span class="tab-scroll"
                    >{{ request?.trainingId?.start_date | date }} -
                    {{ request?.trainingId?.end_date | date }}</span
                  >
                </div>
              </span>
            </td>

            <td *ngIf="selected == 'MONTHLY'" data-label="Factor">
              <span class="ms-tabel-td-mob-mr tab-card-width-mob">
                <div class="tabel-detail-box">
                  <span class="tab-scroll"
                    >{{ request?.date?.month }} {{ request?.date?.year }}</span
                  >
                </div>
              </span>
            </td>

            <td *ngIf="status && status === 'REJECTED'" data-label="Factor">
              <span class="ms-tabel-td-mob-mr tab-card-width-mob">
                <div class="tabel-detail-box">
                  <span
                    *ngIf="
                      request.reason != 'Auto Rejection due to week change';
                      else rejectBlock
                    "
                    class="tab-scroll-for-column-ui"
                    [innerHTML]="request?.reason ?? request?.reason | safeHTML"
                  ></span>
                  <ng-template #rejectBlock>{{
                    "Auto Rejection due to week change" | translator
                  }}</ng-template>
                </div>
              </span>
            </td>

            <td>
              <span class="ms-tabel-td-mob-mr tab-card-width-mob">
                <div class="tabel-detail-box mob-height">
                  <div
                    class="d-flex justify-content-between w-100 align-items-center"
                  >
                    <div class="d-flex flex-wrap">
                      <div
                        [hidden]="!hasPermission('CONTINUOUS_TRAINING_APPROVE', 'a') "
                        tooltipPosition="top"
                        *ngIf="request.status === 'PENDING'"
                        (click)="approve(request?._id)"
                        class="tabel-circle-btn"
                      >
                        <i class="fa-solid fa-check"></i>
                      </div>

                      <div
                        pTooltip="{{ 'Create Training' | translator }}"
                        [hidden]="!hasPermission('CONTINUOUS_TRAINING', 'c') "
                        tooltipPosition="top"
                        *ngIf="request.status === 'APPROVED'"
                        (click)="
                          requestHolder = request;
                          createCourseModal = true;
                          openCourseModal = false;
                          fromCreateTraining = true
                        "
                        class="tabel-circle-btn"
                      >
                        <i class="fa-solid fa-plus"></i>
                      </div>

                      <div
                        pTooltip="{{ 'Reject' | translator }}"
                        tooltipPosition="top"
                        [hidden]="!hasPermission('CONTINUOUS_TRAINING_APPROVE', 'a') "
                        *ngIf="
                          request.status === 'PENDING' ||
                          request.status === 'APPROVED' ||
                          showRejectButton(request)
                        "
                        (click)="
                          rejectReason = true;
                          rejectData.status = 'REJECTED';
                          rejectData._id = request._id
                        "
                        class="tabel-circle-btn"
                      >
                        <i class="fa-solid fa-xmark"></i>
                      </div>

                      <div
                        pTooltip="{{ 'draft' | translator }}"
                        tooltipPosition="top"
                        *ngIf="
                          ((request.status == 'TRAINING_CREATED' ||
                            request.status == 'PUBLISHED' ||
                            request.status == 'COMPLETED') &&
                            hasPermission('CONTINUOUS_TRAINING', 'u')) ||
                          hasPermission('TRAINING_EDIT_ADMIN', 'a')
                        "
                        (click)="openCourse(request)"
                        class="tabel-circle-btn"
                      >
                        <i class="fa-solid fa-file-pen"></i>
                      </div>

                      <div
                        pTooltip="{{ 'Publish' | translator }}"
                        tooltipPosition="top"
                        *ngIf="
                          request.status === 'TRAINING_CREATED' &&
                          request?.trainingId?.attendees.length > 0 &&
                          hasPermission('CONTINUOUS_TRAINING_PUBLISH', 'a')
                        "
                        (click)="publish(request?._id)"
                        class="tabel-circle-btn"
                      >
                        <i class="fa-solid fa-bullhorn"></i>
                      </div>

                      <div
                        pTooltip="{{ 'Assign Users' | translator }}"
                        tooltipPosition="top"
                        *ngIf="
                          request.status == 'TRAINING_CREATED' &&
                          hasPermission('CONTINUOUS_TRAINING_PUBLISH', 'a')
                        "
                        (click)="addAttendees(request)"
                        class="tabel-circle-btn"
                      >
                        <i class="fa-solid fa-user-plus"></i>
                      </div>

                      <div
                        pTooltip="{{ 'Deactivate Training' | translator }}"
                        [hidden]="
                          !hasPermission('CONTINUOUS_TRAINING_ACTIVE', 'a')
                        "
                        tooltipPosition="top"
                        *ngIf="
                          request.active == true &&
                          request.status !== 'PUBLISHED' &&
                          request.status !== 'COMPLETED'
                        "
                        (click)="changeActivation(request?._id, false)"
                        class="tabel-circle-btn"
                      >
                        <i class="fa-regular fa-circle-stop"></i>
                      </div>

                      <div
                        pTooltip="{{ 'Activate Training' | translator }}"
                        [hidden]="
                          !hasPermission('CONTINUOUS_TRAINING_ACTIVE', 'a')
                        "
                        tooltipPosition="top"
                        *ngIf="
                          request.active == false &&
                          request.status !== 'PUBLISHED' &&
                          request.status !== 'COMPLETED'
                        "
                        (click)="changeActivation(request?._id, true)"
                        class="tabel-circle-btn"
                      >
                        <i class="fa-regular fa-circle-left"></i>
                      </div>

                      <div
                        pTooltip="{{ 'View' | translator }}"
                        [hidden]="
                          !hasPermission('CONTINUOUS_TRAINING', 'r') ||
                          request.status === 'PENDING' ||
                          request.status === 'REJECTED' ||
                          request.status === 'APPROVED'
                        "
                        tooltipPosition="top"
                        (click)="openCourse(request, true)"
                        class="tabel-circle-btn"
                      >
                        <i class="fa fa-eye"></i>
                      </div>


                      <div pTooltip="{{ 'Results' | translator }}" tooltipPosition="top" *ngIf=" (request.status === 'PUBLISHED' ||
                          request.status == 'COMPLETED') &&
                          hasPermission('CONTINUOUS_TRAINING_PUBLISH', 'a')"  class="tabel-circle-btn"
                        [routerLink]="'/training/training-results/' + request?.trainingId._id"
                        [queryParams]="{ back: '/training/task-view' }"
                        >
                        <i class="pi pi-chart-bar"></i>
                      </div>

                      <div
                        pTooltip="{{ 'Delete training' | translator }}"
                        [hidden]="
                          !hasPermission('CONTINUOUS_TRAINING_REQUEST', 'd')
                        "
                        tooltipPosition="top"
                        *ngIf="
                          request.status !== 'PUBLISHED' &&
                          request.status !== 'COMPLETED'
                        "
                        (click)="deleteRequest(request?._id)"
                        class="tabel-circle-btn"
                      >
                        <i class="fa fa-trash"></i>
                      </div>

                      <div
                        pTooltip="{{ 'Add to Kl' | translator }}"
                        tooltipPosition="top"
                        *ngIf="
                          (request.status === 'PUBLISHED' ||
                            request.status == 'COMPLETED') &&
                          hasPermission('CONTINUOUS_TRAINING_PUBLISH', 'a')
                        "
                        (click)="
                          selectKLCourse = request; openAddKLModal = true
                        "
                        class="tabel-circle-btn"
                      >
                        <i class="pi pi-book"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="mb-5 flex justify-content-center">
      <p-paginator
        [hidden]="totalTraining <= 0"
        (onPageChange)="onPageChange($event)"
        [first]="first"
        [rows]="rows"
        [totalRecords]="totalTraining"
        [rowsPerPageOptions]="[10, 20, 30]"
      ></p-paginator>
    </div>
  </section>

  <section *ngIf="createCourseModal && !openCourseModal">
    <app-create-course
      [data]="requestHolder"
      [fromCreateTraining]="fromCreateTraining"
    ></app-create-course>
  </section>

  <section class="bg-lightt" *ngIf="openCourseModal && !createCourseModal">
    <app-show-detail
      [pageCall]="'View'"
      *ngIf="trainingDetails != undefined"
      [permissions]="permissions"
      [courseDetails]="trainingDetails"
    ></app-show-detail>
  </section>

  <!-- Assign User -->
  <section *ngIf="addTrainer">
    <app-assign-users
      [userFetchUrl]="'user/training-users/'"
      [selectionData]="usersInCourse"
      (selectedUsersList)="assNewTrainers($event)"
      [query]="getUserQuery"
      *ngIf="addTrainer"
      [isTraining]="true"
    >
    </app-assign-users>
  </section>
  <!-- Assign User -->

  <app-footer></app-footer>

  <!-- Accept Reject Modal -->
  <div class="card flex justify-content-center">
    <p-dialog
      [blockScroll]="true"
      [draggable]="false"
      header="{{ 'the reason' | translator }}"
      [(visible)]="rejectReason"
      [style]="{ margin: '0rem 1rem', width: '95vw', maxWidth: '600px' }"
      [maximizable]="true"
    >
      <div class="w-100">
        <p>{{ "the reason" | translator }}</p>
        <p-editor [(ngModel)]="rejectData.reason" [style]="{ height: '320px' }">
        </p-editor>
        <p *ngIf="reasonError" style="color: red">{{ reasonError }}</p>
      </div>
      <ng-template pTemplate="footer">
        <button class="v4-btn-every py-2" (click)="deactivateInit()">
          <i class="pi pi-check v4-ml-2"></i>{{ "OK" | translator }}
        </button>
      </ng-template>
    </p-dialog>
  </div>

  <p-dialog
    header="{{ 'Reason' | translator }}"
    [(visible)]="openAddKLModal"
    [style]="{ width: '90vw' }"
  >
    <app-add-training-kl
      *ngIf="openAddKLModal"
      [courseId]="selectKLCourse._id"
      [ou]="selectKLCourse.ou._id"
      (submitSucces)="librarySubmit($event)"
    ></app-add-training-kl>
  </p-dialog>

  <p-confirmDialog [style]="{ margin: '0rem 1rem' }"></p-confirmDialog>
</div>

<p-toast></p-toast>
